import { render } from "./GoalReferenceFolders.vue?vue&type=template&id=81473c70"
import script from "./GoalReferenceFolders.vue?vue&type=script&lang=js"
export * from "./GoalReferenceFolders.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__